import { useLocation } from "react-router-dom";
// A custom hook that builds on useLocation to parse
// the query string for you.
export const useQueryString = () => {
    //TODO - Look at including a polyfill for this (there's one in the core-js library)
    return new URLSearchParams(useLocation().search);
};
